import { render, staticRenderFns } from "./Solve.vue?vue&type=template&id=972badac&scoped=true&"
import script from "./Solve.vue?vue&type=script&lang=js&"
export * from "./Solve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972badac",
  null
  
)

export default component.exports